import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PAGES, SITE_URL, SITE_NAME, canonicalFor } from "../seo/seoData";

// Schema.org / JSON-LD — ausschliesslich Angaben, die auf der Website vorhanden sind
// (Impressum, Kontaktsektion, Ueber-mich). Keine erfundenen Daten.
// Struktur: WebPage (pro Route) + WebSite + ProfessionalService + Person + Service (Leistungsseiten).

const SCRIPT_ID = "df-schema-org";

const PERSON_ID = `${SITE_URL}/#person`;
const BUSINESS_ID = `${SITE_URL}/#business`;
const WEBSITE_ID = `${SITE_URL}/#website`;

const ADDRESS = {
  "@type": "PostalAddress",
  streetAddress: "Ferihumerstraße 46, Tür 48",
  postalCode: "4040",
  addressLocality: "Linz",
  addressCountry: "AT",
};

const personNode = {
  "@type": "Person",
  "@id": PERSON_ID,
  name: "Ing. David Frank, MSc.",
  alternateName: "David Frank",
  jobTitle: "Leadership Trainer & Organisationsentwickler",
  description: PAGES["/ueber-mich"].description,
  url: `${SITE_URL}/ueber-mich`,
  image: `${SITE_URL}/images/david-umdasch.jpg`,
  email: "david@davidfrank.at",
  telephone: "+43 681 81964809",
  address: ADDRESS,
  sameAs: ["https://www.linkedin.com/in/david-frank-780b501b1/"],
  alumniOf: [{ "@type": "CollegeOrUniversity", name: "Sigmund Freud Privatuniversität Wien" }],
  knowsAbout: [
    "Leadership-Entwicklung",
    "Teamentwicklung",
    "Organisationsentwicklung",
    "Dynamische Strategie",
    "Change Management",
    "Psychologische Sicherheit",
  ],
  worksFor: { "@id": BUSINESS_ID },
};

const businessNode = {
  "@type": "ProfessionalService",
  "@id": BUSINESS_ID,
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  image: `${SITE_URL}/images/og-image.jpg`,
  email: "david@davidfrank.at",
  telephone: "+43 681 81964809",
  address: ADDRESS,
  founder: { "@id": PERSON_ID },
  description: PAGES["/"].description,
};

const websiteNode = {
  "@type": "WebSite",
  "@id": WEBSITE_ID,
  url: `${SITE_URL}/`,
  name: SITE_NAME,
  inLanguage: "de",
  publisher: { "@id": BUSINESS_ID },
};

const SERVICES = [
  { id: "leadership-training", name: "Leadership Training / Führungskräfteentwicklung", page: "/leadership" },
  { id: "teamentwicklung", name: "Teamentwicklung", page: "/team" },
  { id: "organisationsentwicklung", name: "Organisationsentwicklung", page: "/organisation" },
  { id: "strategieentwicklung", name: "Strategieentwicklung", page: "/strategie" },
];

const serviceNode = (s) => ({
  "@type": "Service",
  "@id": `${SITE_URL}/#${s.id}`,
  name: s.name,
  serviceType: s.name,
  provider: { "@id": BUSINESS_ID },
  url: `${SITE_URL}${s.page}`,
  description: PAGES[s.page].description,
});

export const Schema = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const key = PAGES[pathname] ? pathname : "/";
    const canonical = canonicalFor(key);
    const pageNode = {
      "@type": "WebPage",
      "@id": `${canonical}#webpage`,
      url: canonical,
      name: PAGES[key].title,
      description: PAGES[key].description,
      inLanguage: "de",
      isPartOf: { "@id": WEBSITE_ID },
      about: { "@id": key === "/ueber-mich" ? PERSON_ID : BUSINESS_ID },
    };
    const graph = [pageNode, websiteNode, businessNode, personNode];
    if (key === "/") {
      graph.push(...SERVICES.map(serviceNode));
    } else {
      const own = SERVICES.find((s) => s.page === key);
      if (own) graph.push(serviceNode(own));
    }
    let el = document.getElementById(SCRIPT_ID);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = SCRIPT_ID;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
  }, [pathname]);
  return null;
};
